import { AfterViewInit, QueryList } from '@angular/core';
import { PlaySportsDetailGridItemComponent } from './play-sports-detail-grid-item/play-sports-detail-grid-item.component';
import { PageNames } from '../../shared/page-names.enum';
import { NavigationService } from '../../services/navigation/navigation.service';
import { TvshopConstants } from '../../shared/tvshop-constants';
import { Environment } from '../../shared/environment/environment';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
var ProductDetailOfferComponent = /** @class */ (function () {
    function ProductDetailOfferComponent(navigationService) {
        this.navigationService = navigationService;
        this.sportsArray = [
            { name: 'football', active: false },
            { name: 'tennis', active: false },
            { name: 'golf', active: false },
            { name: 'volleyball', active: false },
            { name: 'racing', active: false },
            { name: 'cycling', active: false }
        ];
    }
    ProductDetailOfferComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.divideInRowsByElementPosition(PageNames.DETAIL_PAGE_OFFER, this.sportsChildren.toArray());
    };
    Object.defineProperty(ProductDetailOfferComponent.prototype, "bannerUrl", {
        get: function () {
            if (this._bannerUrl) {
                return this._bannerUrl;
            }
            return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.omapiId) + '-' + this.sportsArray[0].name + '-banner.png';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductDetailOfferComponent.prototype, "backgroundImageUrl", {
        get: function () {
            return this.baseUrl() + TvshopConstants.IMAGES_AEM_PATH + OmapiIdsUtils.getCorrectIdForResource(this.omapiId) + '-offer.jpg';
        },
        enumerable: true,
        configurable: true
    });
    ProductDetailOfferComponent.prototype.changeBannerInfo = function (event) {
        this._bannerUrl = event.url;
    };
    ProductDetailOfferComponent.prototype.baseUrl = function () {
        return Environment.environmentConfig().baseUrl;
    };
    return ProductDetailOfferComponent;
}());
export { ProductDetailOfferComponent };
